import React from 'react';
import { Nav, Navbar, NavItem } from 'reactstrap';
import bn from '../../../lib/utils/bemnames';
import SourceLink from '../SourceLink';

const bem = bn.create('footer');

const Footer = () => (
	<Navbar className={bem.b('')}>
		<Nav navbar>
			<NavItem>
				2023{' '}
				<SourceLink link="http://www.sagasistemas.com.br/">
					Fante - Portal de Gestão
				</SourceLink>
			</NavItem>
		</Nav>
	</Navbar>
);

export default Footer;
